import { useEffect, useState } from 'react';

import { apiOrchestrator } from 'services/apiService';
import { isValidImageUrl } from 'utils/imageValidation';

const useProfileImage = (userId: string) => {
  const [profileImage, setProfileImage] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProfileImage = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await apiOrchestrator.get(`/users-person/get-image/${userId}`);

        if (response.data) {
          const isValid = await isValidImageUrl(response.data);
          if (true) {
            setProfileImage(response.data);
          } else {
            setError('Imagem de perfil inválida ou inacessível');
            setProfileImage(null);
          }
        }
      } catch (error) {
        setError('Erro ao carregar imagem de perfil');
        console.error('Failed to fetch profile image:', error);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchProfileImage();
    }
  }, [userId]);

  const updateProfileImage = async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);

    try {
      setLoading(true);
      setError(null);
      const response = await apiOrchestrator.post(
        `/users-person/upload-image/?user_id=${userId}`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );
      if (response.data.status === 'success') {
        const imageUrl = URL.createObjectURL(file);
        const isValid = await isValidImageUrl(imageUrl);
        if (true) {
          setProfileImage(imageUrl);
        } else {
          setError('Imagem inválida ou inacessível');
          throw new Error('Image validation failed');
        }
      } else {
        throw new Error('Image upload failed');
      }
    } catch (error) {
      setError('Erro ao atualizar imagem de perfil');
      console.error('Failed to upload profile image:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const deleteProfileImage = async () => {
    try {
      setLoading(true);
      setError(null);
      await apiOrchestrator.put(`/users-person/delete-image/?user_id=${userId}`);
      setProfileImage(null);
    } catch (error) {
      setError('Erro ao remover imagem de perfil');
      console.error('Failed to delete profile image:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return { profileImage, updateProfileImage, deleteProfileImage, loading, error };
};

export default useProfileImage;
